interface Action {
    payload: any,
    type: string,
    field: {
        val: string,
        legend?: any
    },
    uploads?: any
}

const maxLimit = '10';
const maxSize = 10000000;

const errors: {
    [key: string]: string
} = {
    type: "File type must be pdf, jpg, jpeg, png, doc, docx or text.",
    size: "File size cannot exceed 10 MB.",
    limit: "You may attach no more than !limit! files.",
    duplicate: "You already have attached this file."
};


const checkATypes = (fileType: any, fileName: any) => {
    if (fileType === "") {
        const xls = fileName.toLowerCase().indexOf('.xls');
        const xlsx = fileName.toLowerCase().indexOf('.xlsx');
        const doc = fileName.toLowerCase().indexOf('.doc');
        const docx = fileName.toLowerCase().indexOf('.docx');
        if (xls > -1 || xlsx > -1 || doc > -1 || docx > -1) {
            return "word";
        } else {
            return ""
        }
    } else {
        switch (fileType) {
            case "image/png":
                return "image";
            case "application/pdf":
                return "pdf";
            case "image/jpeg":
                return "image";
            case "image/jpg":
                return "image";
            case "application/msword":
                return "word";
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                return "word";
            case "text/plain":
                return "text";
            default:
                return "0";
        }
    }
};

function Validator(data: any, action: Action) {
    const newData = data;
    if (action.uploads.length) {
        if (action.uploads.length + data.uploads.length > maxLimit) {
            newData.invalidItems.push({
                error: errors.limit.replace('!limit!', maxLimit),
            });
            return newData;
        }
        for (const f of action.uploads) {
            if (checkATypes(f.type, f.name).length < 2) {
                f.error = errors.type;
                newData.invalidItems.push(f);
            } else if (f.size > maxSize) {
                f.error = errors.size;
                newData.invalidItems.push(f);
            } else if (data.uploads.find((item: any) => item.name === f.name)) {
                f.error = errors.duplicate;
                newData.invalidItems.push(f);
            } else {
                newData.validItems.push(f)
            }
        }
    }

    return newData;
}

function Reset(data: any, action: Action) {

    const newData = data;

    if (typeof action.field === 'object') {
        newData[action.field.val] = newData[action.field.val].filter((f: any) => f.name !== action.field.legend);
    } else {
        newData[action.field] = [];
    }

    return newData;
}

export default {
    Validator,
    Reset
}
